import { render, staticRenderFns } from "./veStuHygieneModify.vue?vue&type=template&id=f8023000&scoped=true"
import script from "./veStuHygieneModify.vue?vue&type=script&lang=js"
export * from "./veStuHygieneModify.vue?vue&type=script&lang=js"
import style0 from "./veStuHygieneModify.vue?vue&type=style&index=0&id=f8023000&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8023000",
  null
  
)

export default component.exports